



























import mixins from 'vue-typed-mixins';
import { ServiceProviderType } from '../../utils/ProviderUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => ServiceProviderType,
    },
  },
});
